import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";

// Components
import Screen from "@Components/Screen";
import IkTable from "@Components/IkTable";

// Redux
import { connect } from "react-redux";

// Utils
import dataHandler from "@Utils/dataHandler";

// Modal
import ContactCrud from "./Modals/ContactCrud";
import ContactLink from "./Modals/ContactLink";

// Styles
import styles from "./styles.module.css";

const Contact = ({ companyName, userName, dispatch, isBlockedSettings }) => {
	const [filteredItems, setFilteredItems] = useState([]);
	const [tableValue, setTableValue] = useState("");
	const [openContactCrud, setOpenContactCrud] = useState(false);
	const [modalOption, setModalOption] = useState("");
	const [openContactLink, setOpenContactLink] = useState(false);
	const [filteredCount, setFilteredCount] = useState(null);
	const [filteredPrintData, setFilteredPrintData] = useState([]);
	const [lastFilteredParams, setLastFilteredParams] = useState({});
	const defaultParams = { page: 1, orderKey: "id", orderDir: "desc", rows: 15 };

	const transformContacts = (items) => {
		if (!items || !items.map) return [];

		return items.map((item) => {
			const grupoField = item.companyContactFields?.find((field) => {
				return field.type === "group";
			});
			return {
				...item,
				group: grupoField ? grupoField.value : "—",
			};
		});
	};

	useEffect(() => {
		(async () => {
			const contactResponse = await dataHandler({
				dispatch,
				url: "contacts",
				params: defaultParams,
			});

			const transformedItems = transformContacts(contactResponse.items);

			setFilteredCount(contactResponse.count);
			setFilteredItems(transformedItems);
			setLastFilteredParams(defaultParams);
		})();
	}, []);

	const modalData = (name, item) => {
		setModalOption(name);
		setTableValue(item);
		setOpenContactCrud(true);
	};

	const handleButtom = (name, item) => {
		switch (name) {
			case "Watch":
			case "Edit":
				modalData(name, item);
				break;
			default:
				break;
		}
	};

	const apiData = async (name) => {
		switch (name) {
			case "Edit":
			case "unlink":
			case "link":
				setOpenContactCrud(false);
				setOpenContactLink(false);
				break;
			default:
				break;
		}

		const profilesResponse = await dataHandler({
			dispatch,
			url: "contacts",
			params: defaultParams,
		});

		const transformedItems = transformContacts(profilesResponse.items);

		setFilteredCount(profilesResponse.count);
		setFilteredItems(transformedItems);
	};

	const handlerData = async (params, printable) => {
		const mergedParams = {
			...params,
			fields: "id,contact.channel,name,phone,email",
		};
		const data = await dataHandler({ dispatch, url: "contacts", params: mergedParams });
		const transformedItems = transformContacts(data.items);

		if (printable) {
			setFilteredPrintData(transformedItems);
		} else {
			setFilteredItems(transformedItems);
			setFilteredCount(data.count);
		}
	};

	const refresh = async () => {
		const profilesResponse = await dataHandler({
			dispatch,
			url: "contacts",
			params: lastFilteredParams,
		});

		const transformedItems = transformContacts(profilesResponse.items);

		setFilteredItems(transformedItems);
		setFilteredCount(profilesResponse.count);
	};

	const setRowStyle = (item) => {
		if (item.isBlocked) {
			return { backgroundColor: "rgba(255, 0, 0, 0.24)" };
		}
		return null;
	};

	return (
		<Screen hasHeader hasSidebar headerTitle="Contactos">
			<div className={styles.container}>
				<div className={styles.containerTableGroup}>
					<div className={styles.tableGroupList}>
						<IkTable
							data={filteredItems}
							columns={[
								{
									label: "Acciones",
									action: [{ content: "edit", color: "#3f7ea3", onClick: "Edit", type: "icon" }],
									dataPosition: "center",
									width: 1,
									canFilter: false,
									canSort: false,
								},
								{
									label: "ID",
									key: "id",
									format: "string",
									dataPosition: "center",
									width: 1,
								},
								{
									label: "Plataforma",
									key: "contact.channel",
									format: "string",
									dataPosition: "left",
									width: 1,
									canFilter: true,
									canSort: true,
									canPrint: true,
									canExcel: true,
								},
								{
									label: "Grupo",
									key: "group",
									format: "string",
									headerPosition: "left",
									dataPosition: "left",
									width: 1,
									canPrint: true,
									canExcel: true,
									canSort: false,
								},
								{
									label: "Nombre",
									key: "name",
									format: "string",
									width: 1,
									canFilter: true,
									canSort: true,
									canPrint: true,
									canExcel: true,
								},
								{
									label: "Teléfono",
									key: "phone",
									format: "phone",
									dataPosition: "left",
									width: 1,
									canFilter: true,
									canSort: true,
									canPrint: true,
									canExcel: true,
								},
								{
									label: "Correo",
									key: "email",
									format: "string",
									dataPosition: "left",
									headerPosition: "left",
									width: isBlockedSettings ? 1 : 16,
									canFilter: true,
									canSort: true,
									canPrint: true,
									canExcel: true,
								},
								{
									label: "Bloqueado",
									key: "isBlocked",
									format: "boolean",
									dataPosition: "left",
									headerPosition: "left",
									width: 16,
									hidden: !isBlockedSettings,
								},
							]}
							totalRows={filteredCount}
							filteredPrintData={filteredPrintData}
							defaultParams={defaultParams}
							mobileCardView
							cardLine1={[
								{ key: "contactId", label: "ID" },
								{ key: "name", label: "" },
							]}
							cardLine2={[
								{ key: "contact.channel", label: "Plataforma" },
								{ key: "group", label: "Grupo" },
							]}
							cardLine3={[
								{ key: "phone", label: "Teléfono" },
								{ key: "email", label: "Correo" },
							]}
							cardLine4={[{ key: "isBlocked", label: "Bloqueado" }]}
							dataHandler={handlerData}
							handlerTable={handleButtom}
							searcher={{ width: "40rem", hideOnMobile: true }}
							hidePrintButtons
							print={{
								printHeader: {
									company: companyName,
									title: "Contactos",
									user: userName,
								},
							}}
							setRowStyle={setRowStyle}
						/>
					</div>
				</div>
			</div>
			{openContactLink && (
				<ContactLink
					apiData={apiData}
					onClose={() => {
						return setOpenContactLink(false);
					}}
				/>
			)}
			{openContactCrud && (
				<ContactCrud
					apiData={apiData}
					tableValue={tableValue}
					onClose={() => {
						return setOpenContactCrud(false);
					}}
					refresh={refresh}
					modalCrud={modalOption}
				/>
			)}
		</Screen>
	);
};

function mapStateToProps({ user, company }) {
	return {
		contact: [],
		categoryData: [],
		companyName: company.name,
		userName: user.name,
		isBlockedSettings: company.settings.isBlocked,
	};
}

Contact.propTypes = {
	companyName: PropTypes.string,
	userName: PropTypes.string,
	dispatch: PropTypes.func,
	isBlockedSettings: PropTypes.bool,
};

export default connect(mapStateToProps)(Contact);
